import {PERSISTENCE_TO_SOURCE, type ResolvableParameterType} from "@reva/shared/parameter-resolution";

/**
 * Value to persist when a comment is confirmed for a field. The resolved display value turns "empty"
 * ("Keine Angabe") into null; resending that null would delete the field's own override instead of
 * keeping "Keine Angabe", so the stored "empty" of the field's own layer is resent instead (#19774).
 * The overview (AVM) stores its overrides as `reva`, the other layers under their source key; META and
 * DOC_PROPERTY own no layer.
 */
export function commentConfirmValue(
    parameterType: ResolvableParameterType,
    allValues: Record<string, unknown> | null | undefined,
    activeParameterValue: unknown,
): unknown {
    return hasOwnLayerEmptyValue(parameterType, allValues) ? "empty" : activeParameterValue;
}

/** Whether the field's own layer already stores "Keine Angabe" ("empty"). */
export function hasOwnLayerEmptyValue(
    parameterType: ResolvableParameterType,
    allValues: Record<string, unknown> | null | undefined,
): boolean {
    const ownLayerKey =
        parameterType === "AVM"
            ? "reva"
            : (PERSISTENCE_TO_SOURCE as Partial<Record<ResolvableParameterType, string>>)[parameterType];
    return ownLayerKey != null && allValues?.[ownLayerKey] === "empty";
}
